import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { MenuUsers } from "../../Model/menu-users";
import { MenuUsersService } from "../../Services/menu-users.service";

@Component({
  selector: "menu-security-copy",
  templateUrl: "./menu-security-copy.component.html",
  styleUrls: ["./menu-security-copy.component.css"],
})
export class MenuSecurityCopyComponent implements OnInit, OnChanges {
  @Input()
  changeTrigger: number;

  @Output()
  close: EventEmitter<any> = new EventEmitter();

  public form: FormGroup;
  public dialogTitle: string;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private menuUsersService: MenuUsersService
  ) {
    this.createFormGroup();
  }

  createFormGroup() {
    this.form = this.fb.group({
      fromUser: new FormControl([], Validators.required),
      toUser: new FormControl([], Validators.required),
    });
  }

  ngOnChanges() {
    this.form.reset();
  }

  ngOnInit() {}

  onCopyClick() {
    let formData = {
      fromUser: this.form.get("fromUser").value,
      newUser: this.form.get("toUser").value,
    };
    this.menuUsersService.copy(formData).subscribe((response: any) => {
      if (response["success"] != "true") {
        this.toastr.error("Error occurred while copying user/menu");
      } else {
        this.toastr.success("User/Menu copied successfully");
        this.form.reset();
        this.close.emit({});
      }
    });
  }

  closeDialog() {
    this.form.reset();
    this.close.emit({});
  }
}
